import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles, useToolbarStyles } from './VisitaFiliadoTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import StatusBullet from '../../../../components/StatusBullet';
import VisibilityIcon from '@material-ui/icons/Visibility';


function ConexaoUsuarioTable(props) {
  const { conexoesUsuarios } = props;
  const classes = useStyles();


  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          Conexões de usuários no sistema
        </Typography>
      </Toolbar>
    );
  };

  return (
    <Paper className={classes.root}>
      <EnhancedTableToolbar numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_usuario'}
                align={'left'}
              >
                {'Usuário'}
              </TableCell>
              <TableCell
                key={'label_tipo_usuario'}
                align={'left'}
              >
                {'Tipo de usuário'}
              </TableCell>
              <TableCell
                key={'label_data_entrada'}
                align={'left'}
              >
                {'Data entrada no sistema'}
              </TableCell>
              <TableCell
                key={'label_ultima_atividade'}
                align={'left'}
              >
                {'Última atividade no sistema'}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conexoesUsuarios.map((conexao, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={conexao.idConexaoUsuario}
                >
                  <TableCell
                    align={'left'}
                  >
                    {conexao.usuario.nome}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {conexao.usuario.tipoUsuario.descricao}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {moment(conexao.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {moment(conexao.updatedAt).format('DD/MM/YYYY HH:mm:ss')}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ConexaoUsuarioTable;
